import React, { useEffect } from 'react';
import { CardDesign } from '../../../../../../../components/CardDesign';
import Criteria from './Criteria';
import { ReactComponent as CriteriaIcon } from '../../../../../../../resource/CriteriaIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { selectShutdownsFilter } from '../../../model/selectors';
import { applyShutdownFilter } from '../../../model/actions';
import {
  SET_COMPANY_ID_SHUTDOWN_FILTER,
  SET_REASON_ID_SHUTDOWN_FILTER,
  SET_TYPE_ID_SHUTDOWN_FILTER,
  SET_ONLY_ACTIVE_SHUTDOWN_FILTER,
  SET_CITY_ID_SHUTDOWN_FILTER,
  SET_IS_PLAYING_SHUTDOWN_FILTER,
  SET_FOR_EDDS_SHUTDOWN_FILTER,
} from '../../../model/types';
import { useShutdownReasons } from '../../../../../shared/api/queries/shutdownReasons';
import { useShutdownTypes } from '../../../../../shared/api/queries/shutdownTypes';
import useCompanies from '../../../../../../../queries/useCompanies';
import { getOptionsByDrobdownSelect } from '../../../../../shared/utils/getShutdownsOptions';
import { useShutdownCities } from '../../../../../shared/api/queries/shutdownCities';

const optionsBollean = [
  {
    key: 1,
    value: true,
    content: 'Да',
  },
  {
    key: 2,
    value: false,
    content: 'Нет',
  },
];

const CriteriaFilterCard = () => {
  const {
    companyId,
    typeId,
    reasonId,
    onlyActive,
    cityId,
    isPlaying,
    forEdds,
  } = useSelector(selectShutdownsFilter);

  const dispatch = useDispatch();

  const { data: reasonsOptions = [], isFetching: isReasonsFetching } =
    useShutdownReasons();
  const { data: typesOptions = [], isFetching: isTypesFetching } =
    useShutdownTypes();
  const { data: companiesOptions = [], isFetching: isCompaniesFetching } =
    useCompanies();
  const { data: citiesOptions = [], isFetching: isCitiesFetching } =
    useShutdownCities(companyId);

  const makeChangeHandler = (actionType) => (value) => {
    dispatch(applyShutdownFilter(actionType)(value));
  };

  const companyConfig = {
    data: getOptionsByDrobdownSelect(companiesOptions),
    value: companyId,
    onChange: makeChangeHandler(SET_COMPANY_ID_SHUTDOWN_FILTER),
    isLoading: isCompaniesFetching,
    placeholder: 'Управляющая компания',
  };

  const typeConfig = {
    data: getOptionsByDrobdownSelect(typesOptions),
    value: typeId,
    onChange: makeChangeHandler(SET_TYPE_ID_SHUTDOWN_FILTER),
    isLoading: isTypesFetching,
    placeholder: 'Тип',
  };

  const reasonConfig = {
    data: getOptionsByDrobdownSelect(reasonsOptions),
    value: reasonId,
    onChange: makeChangeHandler(SET_REASON_ID_SHUTDOWN_FILTER),
    isLoading: isReasonsFetching,
    placeholder: 'Причина',
  };

  const cityConfig = {
    data: getOptionsByDrobdownSelect(citiesOptions),
    value: cityId,
    onChange: makeChangeHandler(SET_CITY_ID_SHUTDOWN_FILTER),
    isLoading: isCitiesFetching,
    placeholder: 'Город',
  };

  const activeConfig = {
    value: onlyActive,
    onChange: makeChangeHandler(SET_ONLY_ACTIVE_SHUTDOWN_FILTER),
    placeholder: '',
  };

  const isPlayingConfig = {
    value: isPlaying,
    onChange: makeChangeHandler(SET_IS_PLAYING_SHUTDOWN_FILTER),
    data: optionsBollean,
    placeholder: 'Проигрывание',
  };

  const forEddsConfig = {
    value: forEdds,
    onChange: makeChangeHandler(SET_FOR_EDDS_SHUTDOWN_FILTER),
    data: optionsBollean,
    placeholder: 'Отправлено в ЕДДС',
  };

  useEffect(() => {
    if (citiesOptions && citiesOptions?.length === 1) {
      makeChangeHandler(SET_CITY_ID_SHUTDOWN_FILTER)(citiesOptions[0].id);
    }
  }, [citiesOptions]);

  return (
    <CardDesign style={{ backgroundColor: 'white' }}>
      <CardDesign.Header
        heading="Критерии"
        icon={<CriteriaIcon />}
      />

      <CardDesign.Body>
        <Criteria
          activeConfig={activeConfig}
          gridConfigs={[
            companyConfig,
            cityConfig,
            typeConfig,
            reasonConfig,
            isPlayingConfig,
            forEddsConfig,
          ]}
        />
      </CardDesign.Body>
    </CardDesign>
  );
};

export default CriteriaFilterCard;
